var App = App || {};

App.ScrollAnimations = (function ($) {
    "use strict";

    function init() {
        //
        //handling plus "zoom in" generally, wherever it appears
        //
        var plusParents = $(".plus-on-light, .plus-on-dark").parent();
        plusParents.ZagScrollAnimate({
            offset: 90,
            targets: [
                { selector: ".plus-on-light, .plus-on-dark", type: "animate__plus", stagger: 0 }
            ]
        });

        //
        //homepage cards, grow from center
        //
        $(".component-homepage-banner .homepage-banner-inner").ZagScrollAnimate({
            offset: 100,
            targets: [
                { selector: ".feature-card, .homepage-banner-content-card.desktop", type: "animate__hpCard", stagger: 100 }
            ]
        });

        //
        //detail masthead image zoom in
        //
        $(".page-masthead.detail").ZagScrollAnimate({
            offset: 100,
            targets: [
                { selector: ".page-masthead-image", type: "animate__detailImage", stagger: 0 }
            ]
        });

        //
        //fadeUnUp animatons throughout the site
        //

        ////Top of page, 100% offset
            $(".blog-masthead").ZagScrollAnimate({
                offset: 100,
                targets: [
                    { selector: ".blog-posts-featured", type: "animate__fadeInUp", stagger: 0 }
                ]
            });

            $(".blog-posts-lists").ZagScrollAnimate({
                offset: 100,
                targets: [
                    { selector: ".blogpost-column", type: "animate__fadeInUp", stagger: 150 },
                ],
                order: "odd"
            });

            $(".component-landing-masthead").ZagScrollAnimate({
                offset: 100,
                targets: [
                    { selector: ".feature-card-wrapper", type: "animate__fadeInUp", stagger: 150 }
                ],
                order: "odd"
            });

            $(".masthead-subpages-wrapper").ZagScrollAnimate({
                offset: 100,
                targets: [
                    { selector: ".subpage-column", type: "animate__fadeInUp", stagger: 150 },
                ],
                order: "odd"
            });

        ////Components on a blank background, 90% offset
            $(".component-feature-band").ZagScrollAnimate({
                offset: 90,
                targets: [
                    { selector: ".feature-card-wrapper", type: "animate__fadeInUp", stagger: 150 }
                ],
                order: "odd"
            });

            $(".component-form").ZagScrollAnimate({
                offset: 90,
                targets: [
                    { selector: ".component-form-content", type: "animate__fadeInUp", stagger: 0 }
                ]
            });

            $(".component-highlight-band").ZagScrollAnimate({
                offset: 90,
                targets: [
                    { selector: ".highlight-card", type: "animate__fadeInUp", stagger: 150 },
                ]
            });

            $(".component-linksband>.container").ZagScrollAnimate({
                offset: 90,
                targets: [
                    { selector: ".linksband-inner", type: "animate__fadeInUp", stagger: 0 }
                ]
            });

            $(".component-pagecallout").ZagScrollAnimate({
                offset: 90,
                targets: [
                    { selector: ".pagecallout-inner", type: "animate__fadeInUp", stagger: 0 }
                ]
            });

            $(".component-rates-band").ZagScrollAnimate({
                offset: 90,
                targets: [
                    { selector: ".rate-card", type: "animate__fadeInUp", stagger: 150 },
                ],
                order: "even"
            });

            $(".component-sit-band").ZagScrollAnimate({
                offset: 90,
                targets: [
                    { selector: ".sit-band-inner", type: "animate__fadeInUp", stagger: 0 }
                ]
            });

            $(".component-ss-image-band").ZagScrollAnimate({
                offset: 90,
                targets: [
                    { selector: ".ss-image-band-inner", type: "animate__fadeInUp", stagger: 0 }
                ]
            });

            $(".component-testimonialband").ZagScrollAnimate({
                offset: 90,
                targets: [
                    { selector: ".testimonialband-inner", type: "animate__fadeInUp", stagger: 0 }
                ]
            });

            $(".component-video-band").ZagScrollAnimate({
                offset: 90,
                targets: [
                    { selector: ".video-band-inner", type: "animate__fadeInUp", stagger: 0 }
                ]
            });

        ////Items within a band, 80% offset
            $(".component-bb-promo-band").ZagScrollAnimate({
                offset: 80,
                targets: [
                    { selector: ".text-content-wrapper", type: "animate__fadeInUp", stagger: 0 }
                ]
            });

            $(".component-blog-post-related").ZagScrollAnimate({
                offset: 80,
                targets: [
                    { selector: ".blog-post-related-items > div", type: "animate__fadeInUp", stagger: 150 },
                ]
            });

            $(".component-cross-promo-band").ZagScrollAnimate({
                offset: 80,
                targets: [
                    { selector: ".cross-promo-card-wrapper", type: "animate__fadeInUp", stagger: 150 },
                ]
            });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ScrollAnimations.init();
});